import { Moment } from 'moment';
import { Profile } from '../../../common/models/Profile';

export class Project {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly lastAnalysis: Moment | null,
    private readonly defaultProfile: Profile | null,
    private readonly issueCount: number
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getLastAnalysis() {
    return this.lastAnalysis;
  }

  getDefaultProfile() {
    return this.defaultProfile;
  }

  getIssueCount() {
    return this.issueCount;
  }
}
